<template>
    <div style="height: 100%">
        <vs-chip style="height: 60%; top:20%" :color="statusColor(params.value, params.data.id)">{{params.value}}</vs-chip>
    </div>
</template>
<script>
    import Vue from "vue";

    export default Vue.extend({
        methods:{
            statusColor(status, id) {
                switch (status){
                    case this.$t("OffersAdded"):
                        return '#1e272e';
                    case this.$t("OffersChangeNeeded"):
                        return '#ff3f34';
                    case this.$t("OffersReadyForMaking"):
                        return '#34e7e4';
                    case this.$t("OffersTaken"):
                        return '#4bcffa';
                    case this.$t("OffersInWork"):
                        return '#3c40c6';
                    case this.$t("OffersOfferMade"):
                        return '#ffd32a';
                    case this.$t("OffersSentToClient"):
                        return '#ffa801';
                    case this.$t("OffersApproved"):
                        return '#0be881';
                    case this.$t("OffersOrdered"):
                        return '#808e9b';
                    case this.$t("OffersFinished"):
                        return '#05c46b';
                    case this.$t("OffersArchived"):
                        return '#f53b57';
                    default:
                        return 'dark';
                }
            }
        }
    });

</script>
